import { useEffect, useRef } from "react";
import { CommonPage, Content, PageTitle } from "common/Grid";
import { toast } from "react-toastify";
import { SalesUserForm } from "../Common/MainForm";
import { useUpdateSalesUserMutation } from "store/action/salesUserApi";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { captureComponentError } from "utils/sentry";

const EditSalesUser = () => {
  const [updateSalesUser, { isLoading }] = useUpdateSalesUserMutation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const successRef = useRef(false);

  useEffect(() => {
    return () => {
      if (!successRef.current) {
        toast.dismiss();
      }
    };
  }, []);

  if (!state?.user) {
    return <Navigate to="/sales-user" replace />;
  }

  const { user } = state;

  const handleSubmit = async (userInput) => {
    try {
      const payload = {
        ...userInput,
        password: userInput.password === "" ? undefined : userInput.password,
        _id: user._id,
      };
      const response = await updateSalesUser({ body: payload }).unwrap();
      successRef.current = true;
      toast.success(response?.message || "Sales user updated successfully");
      navigate("/sales-user");
    } catch (error) {
      captureComponentError(error, { component: "EditSalesUser", action: "handleSubmit" });
      toast.error(error?.data?.message || "Something went wrong!");
    }
  };

  return (
    <CommonPage>
      <Content>
        <PageTitle title="Update Sales User" />
        <SalesUserForm
          defaultValues={user}
          onSubmit={handleSubmit}
          isLoading={isLoading}
          isEdit={true}
        />
      </Content>
    </CommonPage>
  );
};

export default EditSalesUser;
